<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from './List'
import ChannelEditor from '@/components/channels/Editor'
import EventsEditor from '@/components/events/Editor'
import InstanceEditor from '@/components/instances/Editor'
import BottomSheet from '@/components/BottomSheet'

export default {
  routes: [
    {
      path: "",
      redirect: "/monitor2/list"
    },
    {
      path: "list",
      component: List,
      name: "Monitor2 list",
      meta: {search: false}
    },
    {
      path: "channel/:id",
      name: "Monitor2 edit channel",
      components: {
        default: List,
        bottomEditor: ChannelEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        search: false
      }
    },
    {
      path: "instance/:id",
      name: "Monitor2 edit instance",
      components: {
        default: List,
        bottomEditor: InstanceEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        search: false
      }
    },
    {
      path: "event/:id",
      name: "Monitor2 edit event",
      components: {
        default: List,
        bottomEditor: EventsEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        search: false
      }
    }
  ],
  components: {
    BottomSheet
  }
}
</script>
